import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Api } from './models/api.model';
import { HttpClient } from '@angular/common/http';
import { map, shareReplay } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class ApiService {
    private api$: Observable<Api>;

    constructor(private http: HttpClient) {}

    getApi_V1(): Observable<Api> {
        if (this.api$ == null) {
            this.api$ = this.http
                .get<Api>(`${environment.api_url}/`)
                .pipe(shareReplay(1));
        }
        return this.api$;
    }


    getApi(): Observable<Api> {
        this.api$ = this.http
            .get<Api>(`${environment.api_url}/`)
            .pipe(shareReplay(1));
        return this.api$;
    }

    getRecursos(): Observable<{ nome: string }[]> {
        return this.getApi().pipe(map((api) => api.recursos));
    }

    getPerfil(): Observable<{ nome: string }[]> {
        return this.getApi().pipe(map((api) => api.perfil));
    }
}
